import type { RequestParams } from '../request-params';

export const getUrlFromParams = (params: RequestParams): string => {
  const baseSegments = [
    params.host ?? '',
    'api',
    params.version,
    params.service,
    params.method,
  ];

  const indexToInsertDomain = params.withLeadingDomain ? 1 : 3;

  baseSegments.splice(indexToInsertDomain, 0, params.domain);

  return baseSegments.join('/');
};
